/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AWSSecrets } from './aWSSecrets';
import { Network } from './network';
import { RDSDbSubnet } from './rDSDbSubnet';
import { S3BucketDeletionInfo } from './s3BucketDeletionInfo';


export interface DeleteAWSResourceResponse { 
    aws_secrets?: Array<AWSSecrets>;
    buckets?: Array<S3BucketDeletionInfo>;
    cloud_formation_stacks?: Array<string>;
    dynamodb_table?: Array<string>;
    ec2_instances?: Array<string>;
    lambda_triggers?: Array<string>;
    lambdas?: Array<string>;
    network?: Array<Network>;
    rds_cluster?: Array<string>;
    rds_instances?: Array<string>;
    rds_subnets?: Array<RDSDbSubnet>;
}

